import React, { ReactNode, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useNotifyMobile } from '../api/main'
import { useModalApiError } from '../hook'
import { Styled_Button_Delete, Styled_Button_Main } from '../styles/button'
import { theme } from '../styles/theme'
import LoadingDots from './Loading'

type Button_Main_type = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  $bgColor?: string
  $width?: string
  $height?: string
  $isLoading?: boolean
  children: ReactNode
  type?: 'button' | 'reset' | 'submit' | undefined
}

export const Button_Main = ({ onClick, $bgColor, children, $width, $height, $isLoading, type }: Button_Main_type) => {
  return (
    <Styled_Button_Main className={$isLoading ? 'loading' : ''} onClick={onClick} type={type ? type : 'button'} $bgColor={$bgColor} $width={$width} $height={$height}>
      {$isLoading ? <LoadingDots /> : children}
    </Styled_Button_Main>
  )
}

export const Button_Delete = ({ onClick, $bgColor, $width, $height, $isLoading }: Omit<Button_Main_type, 'type' | 'children'>) => {
  return (
    <Styled_Button_Delete className={$isLoading ? 'loading' : ''} onClick={onClick} type={'button'} $bgColor={$bgColor} $width={$width} $height={$height}>
    </Styled_Button_Delete>
  )
}

export const Button_Notice = ({ mobileId }:{ mobileId: string | null }) => {
  //deviceId로 요청하자 

  const [isState, setIsState] = useState('Ready')
  const [ErrorMsg, setErrorMsg] = useState<string[]>([])

  const { mutateAsync: notifyMobile, isPending } = useNotifyMobile()

  const [seconds, setSeconds] = useState(180);
  const minutes = (seconds:number) => Math.floor(seconds / 60);
  const remainingSeconds = (seconds:number) => seconds % 60;

  useEffect(() => {
    if(isState === 'isSuccess' || isState === 'isError'){
      const openTime = Date.now();
      setSeconds(180)
      const interval = setInterval(() => {
        const timeRemaining = Math.floor(180 - ((Date.now() - openTime) / 1000));
        setSeconds(timeRemaining);
        if(timeRemaining <= 0) {
          clearInterval(interval);
          setSeconds(0);
          // 여기서 버튼활성화해주자
          setIsState('Ready')
        }
      }, 1000);

      // 인터벌을 정리
      return () => clearInterval(interval);
    }
  }, [isState]);

  const uploadItem = async () => {
    if (isPending) return
    try {
      if(!mobileId || mobileId === "") return
      setIsState('Loading')
      await notifyMobile({mobileId})
      setIsState('isSuccess')
    } catch (error: unknown) {
      setIsState('isError')
      useModalApiError(error,setErrorMsg)
    }
  }

  const getTime = (seconds:number) => `${minutes(seconds)}:${remainingSeconds(seconds) < 10 ? `0${remainingSeconds(seconds)}` : remainingSeconds(seconds)}`
  
  if(isState === 'isSuccess') return (<Label_Box $color={theme.colors.blue} >전송성공({getTime(seconds)} 후 재시도 가능)</Label_Box>)
  if(isState === 'isError') return (<Label_Box $color={theme.colors.red} >전송실패({getTime(seconds)} 후 재시도 가능 이유:{ErrorMsg})</Label_Box>)
  if(!mobileId  || mobileId === "") return (<Label_Box $color={theme.colors.blackgray} >연동 모바일 없음</Label_Box>)
  return (<Button_Main onClick={uploadItem} $isLoading={isState === 'Loading'}>전송하기</Button_Main>)


}

const Label_Box = styled.div<{ $color:string }>`
  background-color:  ${({$color}) => $color};
  color: ${theme.colors.white};
  cursor: not-allowed;
  padding: 10px 20px;
  font-size: 1rem;
  border-radius: 10px;
  overflow: hidden;
  text-overflow: ellipsis; /* 넘치는 텍스트를 ...으로 표시 */
`